import * as React from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { useTranslation } from 'react-i18next';

import AddressSelection from '../../../../shared/containers/AddressSelection';
import { RootState } from '../../../../shared/store/reducers';
import Widget from '../Widget';
import { APP_ENV } from '../../../../shared/config/constants';
import { SENTRY_DSN } from '../../config/constants';

import './style.scss';

if (APP_ENV !== 'development' && APP_ENV !== 'ci') {
  Sentry.init({
    dsn: String(SENTRY_DSN),
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
    allowUrls: [/^https?:\/\/[^/]+\/libraries\/hvc_widgets\//],
  });
}

const ContainerLocations = () => {
  const address = useSelector((state: RootState) => state.geolocation.selected);
  const { t } = useTranslation();

  const onAddressReset = () => {
    const url = new URL(window.location.href);
    window.history.replaceState({}, '', url.toString());
  };

  return (
    <>
      <div className="u-indent--large">
        <AddressSelection
          onAddressReset={onAddressReset}
          buttonLabel={t('container_locations.buttons.show_map')}
        />
      </div>
      {address && (
        <Widget address={address} />
      )}
    </>
  );
};

export default ContainerLocations;
